import { colors } from 'inpock-ui-react/dist/src/color';
import { Paragraph1, SmallText } from 'inpock-ui-react';

import { DashDivider, OrderInfoLine } from '@/components';

import { SummaryInfo } from '../types';

import * as S from './styled';

interface SummarySectionProps {
  summaryInfo: SummaryInfo;
  isSangan: boolean;
}

export function SummarySection(props: SummarySectionProps) {
  const { summaryInfo } = props;

  return (
    <div style={{ marginBottom: '140px' }}>
      <S.SectionHeader border>
        <Paragraph1 fontWeight="bold">결제 정보</Paragraph1>
      </S.SectionHeader>
      <S.SectionBody>
        <OrderInfoLine
          label="총 상품금액"
          labelColor="gray700"
          content={`${summaryInfo.totalPrice.toLocaleString()}원`}
        />
        <OrderInfoLine
          label={(props.isSangan ? '도서산간 ' : '총 ') + '배송비'}
          labelColor="gray700"
          content={
            summaryInfo.totalShippingFee === 0
              ? '무료'
              : `${summaryInfo.totalShippingFee.toLocaleString()}원`
          }
        />
        {summaryInfo.totalDiscount ? (
          <OrderInfoLine
            label="상품 할인"
            labelColor="gray700"
            content={`${summaryInfo.totalDiscount?.toLocaleString()}원`}
          />
        ) : (
          <></>
        )}
        <DashDivider color={colors.gray300} />
        <OrderInfoLine
          label="총 주문금액"
          labelColor="gray700"
          content={`${summaryInfo.totalCost.toLocaleString()}원`}
          valueColor="orange"
          sx={{ marginBottom: '4px' }}
        />

        <SmallText color="gray400">
          에이비제트(주)는 통신판매의 당사자가 아닙니다. 상품, 상품정보, 거래에 관한 의무와 책임은
          판매자에게 있습니다.
        </SmallText>
      </S.SectionBody>
    </div>
  );
}
